import React from 'react';
import { StructuredText } from 'react-datocms';
import Button from './button';
import EmojiListGrid from './emoji-list-grid';
import EmojiListItem from './emoji-list-item';
import CustomForm from './form';

const TextContent = ({ data }) => {
	return (
		<StructuredText
			data={data}
			renderBlock={({ record }) => {
				if (record.__typename === 'DatoCmsLede') {
					return <p className='lede'>{record.text}</p>;
				}
				if (record.__typename === 'DatoCmsButton') {
					return (
						<Button
							size={record.size}
							url={record.url}
							emoji={record.emoji !== null && record.emoji.image}
						>
							{record.text}
						</Button>
					);
				}
				if (record.__typename === 'DatoCmsEmojiListItem') {
					return <EmojiListItem data={record} />;
				}
				if (record.__typename === 'DatoCmsEmojiListGrid') {
					return <EmojiListGrid data={record} />;
				}
				if (record.__typename === 'DatoCmsForm') {
					return <CustomForm data={record} />;
				}
				return <p>Woops! Something went wrong...</p>;
			}}
		/>
	);
};
export default TextContent;
